module.exports = __webpack_public_path__ + "static/media/logo-residencia.fc416df1.svg";